(function($) {

	'use strict';

	var init = function() {

		trackCall();
		trackLink();
		trackPage();
		trackForm();
		trackSocial();
        
	}

	var trackCall = function() {
        //Header tel link
		if( $('.link-tel a').length > 0 ) {

			$('.link-tel a').on('click', function(event) {

                gtag('event', 'call_link', {
                    'event_category': 'call',
                    'event_label': 'Appel depuis le Header',
                });

			});
		}

        
	}

    var trackLink = function() {

        //Sticky contact link
        if( $('.anchor-call').length > 0 ) {

            $('.anchor-call').on('click', function(event) {

                gtag('event', 'contact_link', {
                    'event_category': 'link',
                    'event_label': 'Lien vers page contact depuis le bouton sticky',
                });

            });
        }

    }

    var trackPage = function() {

        //Page contact => 452 (si modification de la page contact => changer ID)
        if( $('.page-id-452').length > 0 ) {

            gtag('event', 'page_contact', {
                'event_category': 'page_view',
                'event_label': 'Affichage de la page contact',
            });

        }

    }

    var trackForm = function() {

        //Form contact
		if( $('#gform_2 .gform_button').length > 0 ) {

            $(document).bind('gform_confirmation_loaded', function(event, formId){
                //ID Form contact = 2
				if(formId == 2) {
					gtag('event', 'contact_form_submission', {
                        'event_category': 'form_submission',
                        'event_label': 'Envoi d\'un message via le formulaire de contact',
                    });
				}
			});
		}

        //Form newsletter
		if( $('.preFooter__newsletter .gform_button').length > 0 ) {

            $(document).bind('gform_confirmation_loaded', function(event, formId){
                //ID Form newsletter = 1
				if(formId == 1) {
					gtag('event', 'newsletter_subcription', {
                        'event_category': 'form_submission',
                        'event_label': 'Inscription à la newsletter',
                    });
				}
			});
		}
	}

    var trackSocial = function() {

        //Social links on news
		if( $('.socialFollow__list__item').length > 0 ) {

            $('.socialFollow__list__item').on('click', function(event){

                gtag('event', 'social_link_news', {
                    'event_category': 'social',
                    'event_label': 'Lien vers les réseaux sociaux sur les news',
                });

			});
		}

        //Social links on footer
		if( $('.mainFooter__social__link').length > 0 ) {

            $('.mainFooter__social__link').on('click', function(event){

                gtag('event', 'social_link_footer', {
                    'event_category': 'social',
                    'event_label': 'Lien vers les réseaux sociaux du footer',
                });

			});
		}

        //Share link
		if( $('.socialShare__list__item').length > 0 ) {

            $('.socialShare__list__item').on('click', function(event){

                gtag('event', 'share', {
                    'event_category': 'share',
                    'event_label': 'Partage sur les réseaux sociaux',
                });

			});
		}

	}

	$(document).ready(function() {
		init();
	});

})(jQuery);